import ScribeLoginProfiling from './ScribeLoginProfiling';
export default ScribeLoginProfiling;
